<!--  -->
<template>
  <div :class="['resultBox', { inApp: $root.$data.isApp }]">
    <common-title titleName="压力测试" :bcColor="'#fff'" :zIndex="1000"> </common-title>
    <section class="drawReaultCenter">
      <img class="photo" :src="photoUrl" alt="" />
    </section>
    <div class="saveBottom">
      <img class="save-btn" :src="imgsList[3]" alt="" @click="toReward" />
      <img class="share-btn" :src="imgsList[4]" alt="" @click="toShare" />
    </div>
    <ShareDraw v-if="showShare" />
    <RewardFloor v-if="showReward" :productId="productId"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ShareDraw from './shareDraw.vue';
import RewardFloor from './rewardFloor.vue';
import { reqCouponList } from '@/api/newUser';
import { reqReceiveCoupon } from '@/api/coupon/index';
import { reqSubOrder } from '@/api/pay/index';
import { reqIsBuyProduct, reqCourseDetail } from '@/api/courseDetail/index';

export default {
  components: {
    ShareDraw,
    RewardFloor,
  },
  data() {
    return {
      showShare: false,
      showReward: false,
      loading: true,
      photoUrl: '',
      appUrl: '',
      couponIds: ['6654049830357997568'],
      userAlreadyGet: 0,
      productId: '3986',
      buyInfo:[],
      imgsList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/result3.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/result2.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/result1.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/jiangli.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/zhuanfa.png`,
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 取对应图片
    getRoundNum() {
      let drawNum = this.$route.query.drawNum;
      if (drawNum !== '0' && drawNum !== '1' && drawNum !== '2') {
        drawNum = '2';
      }
      this.photoUrl = this.imgsList[Number(drawNum)];
    },
    // 分享
    toShare() {
      this.showShare = true;
    },
    // 奖励
    toReward() {
      this.showReward = true;
       if (!this.buyInfo?.length) {
        this.receiveCourse();
      }
      this.receiveCoupon();
    },
    change() {
      const docEl = document.documentElement;
      if (docEl.clientWidth > 470) {
        setTimeout(() => {
          docEl.style.fontSize = '40px';
        }, 300);
      }
    },
    // 根据优惠券id集合 查询优惠券信息
    async getCouponDetail(couponIds) {
      if (!couponIds.length) return;
      const ids = `couponId=${couponIds?.map((item) => item).join('&couponId=')}`;
      const { code, data } = await reqCouponList(ids);
      if (code === 0 && data) {
        this.userAlreadyGet = data[0]?.userAlreadyGet;
      }
    },
    async receiveCoupon() {
      if (this.userAlreadyGet === 1) return;
      const res = await reqReceiveCoupon({
        couponId: String(this.couponIds[0]),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark,
      });
      // if (res.code === 0) {
      //   this.$toast('领取成功');
      // } else {
      //   this.$toast(res.msg);
      // }
    },
    // 查开课状态
    async checkCourse(id) {
      const token = window.localStorage.getItem('accessToken');
      if (!token) return;
      const { data } = await reqIsBuyProduct(id);
      this.buyInfo = data || [];
    },

    // 免费领取
    async receiveCourse() {
      const skuid = await this.getCourseSku(this.productId);
      const subData = {
        // 订单提交请求对象
        channelMark: 5, // 下单渠道 ：5学员端下单
        products: [
          {
            productId: this.productId,
            quantity: 1, // 产品数量
            type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
          },
        ],
        terminalMark: this.$global.terminalMark,
        orderReferer: '',
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
      };
      subData.products[0].productSkuId = skuid;
      const { code, msg } = await reqSubOrder(subData);
      if (code === 0) {
        setTimeout(async () => {
          await this.checkCourse(this.productId);
          this.$toast.clear();
        }, 500);
      } else {
        this.$toast(msg);
      }
    },
    // 查课程sku
    async getCourseSku(id) {
      const { data } = await reqCourseDetail(id);
      const { productSkuRespVOList } = data;
      return productSkuRespVOList?.[0]?.productSkuId;
    },
  },
  created() {
    this.getCouponDetail(this.couponIds);
    this.checkCourse(this.productId);
    this.getRoundNum();
    this.change();
    window.onresize = () => {
      this.change();
    };
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.resultBox {
  box-sizing: border-box;
  width: 100%;
  padding-top: 100px;
  height: 100vh;
  background: linear-gradient(180deg, #c5fcb8 0%, #dafbc7 100%);

  &.inApp {
    padding-top: 0;
  }
  .drawReaultCenter {
    position: relative;
    width: 100%;
    padding-top: 54px;
    padding-bottom: 140px;
    text-align: center;
    .photo {
      width: 90%;
      height: 100%;
      background-size: cover;
    }
    .code {
      position: absolute;
      top: 1018px;
      left: 502px;
      width: 140px;
      height: 140px;
    }
  }
  .saveBottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    background: #fff;
    height: 130px;
    background: #ffffff;
    box-shadow: 0px -5px 8px 0px rgba(95, 172, 120, 0.09);
    border-radius: 40px 40px 0px 0px;
    .save-btn {
      width: 300px;
      height: 152px;
      margin-top: -70px;
      margin-right: 30px;
    }
    .share-btn {
      width: 300px;
      height: 152px;
      margin-top: -70px;
    }
  }
}
</style>
